import React from 'react';
import { Button } from 'rmwc/Button';

export const MButton = (props) => {
  return (
    <Button
      onClick={props.onClick}
      raised
    >
      {props.label}
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/components/MButton.js